import { Chakra } from "@airhelp/react-ui-components";
import type { TermsProps } from "./Terms.d";

const { Text, Checkbox, Flex } = Chakra;

const termsCheckboxStyles = {
  a: {
    textDecoration: "underline",
  },
};

const Terms = ({ register, isDisabled = false, htmlContent, ...props }: TermsProps) => (
  <Flex alignItems="flex-start" {...props}>
    <Checkbox
      name="agreeWithTerms"
      aria-labelledby="terms"
      ref={register}
      value="Y"
      isRequired
      size="lg"
      mr={2}
      isDisabled={isDisabled}
    />
    <Text
      id="terms"
      color="inherit"
      fontSize="sm"
      textAlign="start"
      dangerouslySetInnerHTML={{
        __html: htmlContent,
      }}
      sx={termsCheckboxStyles}
    />
  </Flex>
);

export default Terms;
